import { fetchSessionHistory } from 'common/components/SessionHistory/services/SessionHistoryApi';
import { useSessionHistoryInfiniteQuery } from 'common/components/SessionHistory/hooks/useSessionHistoryInfiniteQuery.ts';

export const useInfinityRSimSessionHistory = (euicc?: string) => {
  return useSessionHistoryInfiniteQuery({
    queryKey: ['RSimSessionHistory', euicc],
    queryFn: async ({ signal, pageParam }) => {
      return await fetchSessionHistory(euicc!, pageParam as Date, true, signal);
    },
    enabled: !!euicc,
  });
};
